import { Stack } from '@mui/material'

import {
  InServiceIndicator,
  IsOnlineIndicator,
  ProjectIndicator,
  StatusCustomerIndicator,
} from '@/pages/Device/Components/Indicators/Indicators'

export default function Indicators({
  device,
}: Readonly<{ device: DeviceStatus }>) {
  return (
    <Stack direction="row" spacing={1} justifyContent="flex-end" padding={1}>
      <IsOnlineIndicator isOnline={device.isOnline} />
      <InServiceIndicator inService={device.inService} />
      <StatusCustomerIndicator statusCustomer={device.statusCustomer} />
      <ProjectIndicator projectName={device.projectName} />
    </Stack>
  )
}

interface DeviceStatus {
  isOnline?: boolean
  inService?: boolean
  projectName?: string
  statusCustomer?: string
}
